import { graphqlApi } from '@/graphql'
import { baseApi } from '@/services'
import { PaginatedResults, Valuation } from '@/types/unlock'

export const valuationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getValuationsByApplication: builder.query<PaginatedResults<Valuation[]>, string>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/valuation/`,
      providesTags: ['ValuationV2'],
    }),
    createValuation: builder.mutation<
      Valuation,
      { applicationUUID: string; data: Partial<Valuation> }
    >({
      query: ({ applicationUUID, data }) => ({
        method: 'POST',
        url: `v2/applications/${applicationUUID}/valuation/`,
        body: data,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'ValuationV2',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'Escalations',
        'MaxActions',
        'Alert',
        'Documents',
      ],
    }),
    reRunAvms: builder.mutation<void, { data: any }>({
      query: ({ data }) => ({
        method: 'POST',
        url: `v1/valuation/rerun-avms/`,
        body: data,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:applicationValuationsCalcs']))
      },
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'ValuationV2',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'MaxActions',
        'StreamingNote',
        'Alert',
        'PropertyV2',
        'Override',
      ],
    }),
  }),
})

export const {
  useGetValuationsByApplicationQuery,
  useCreateValuationMutation,
  useReRunAvmsMutation,
} = valuationApi
